<template>
  <stat-box :label="label"
            :value="value"
            :bg-color="bgColor"
            :color="color"
            :label-color="labelColor"
            :css-class="cssClass"
            :icon="icon"
            :info="info"
            :size="size"
            :align="align"
  >
    <div class="d-flex">
      {{ value }}
      <b-form-checkbox v-model="checked"
                    :value="checkboxValue"
                    :name="checkboxName"
                    class="ml-auto"
                    @change="change"
      ></b-form-checkbox>
    </div>
  </stat-box>
</template>

<script>
import StatBox from '@/components/Dashboard/StatBox';

export default {
  name: "CheckboxStatBox",
  components: {
    StatBox,
  },
  props: {
    label: {
      type: String,
    },
    color: {
      type: String,
    },
    bgColor: {
      type: String,
    },
    labelColor: {
      type: String,
    },
    value: {
      type: [String, Number],
      required: true,
    },
    cssClass: {
      type: String,
    },
    icon: {
      type: String,
    },
    info: {
      type: String,
    },
    size: {
      type: String,
    },
    align: {
      type: String,
    },
    checkboxName: {
      type: [String, Number],
    },
    checkboxValue: {
      type: [String, Number, Boolean],
      default: true,
    },
    checkboxChecked: {
      type: [Array, String, Number, Boolean],
      default: 0,
    },
    checkboxModel: {
      type: [Array, Object, String, Number]
    },
  },
  data() {
    return {
      checked: false,
    }
  },
  watch: {
    checkboxChecked: {
      handler(newValue) {
        this.checked = newValue;
      },
      immediate: true,
    }
  },
  methods: {
    change(event) {
      this.$emit(
          'change',
          { checkboxValue: this.checkboxValue, checked: event }
      );
    },
  }
}
</script>

<style scoped>

</style>
